export default "__VITE_ASSET__6d0d9b60__"